export default "__VITE_ASSET__XsyQ7X2Z__"